import PageHeading from "Layout/AppMain/PageHeading";
import React, { Fragment } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import { Card, CardBody, Col, Row } from "reactstrap";

const Default = () => {
    return (
        <Fragment>
            <PageHeading />
            <TransitionOnLoad>
                <div>
                    <Row>
                        <Col md="12" lg="12">
                            <Card className="main-card mb-3">
                                <CardBody className="p-3">
                                    Vervanger Page
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </TransitionOnLoad>
        </Fragment>
    )
};

export default Default;